import { getSelectValues } from "~/libs/getData";
import {
  KindRepair,
  LoyaltyType,
  TypeClientReportSrr,
  TypeGoReportSrr,
  TypeGroupReportSrr,
  TypeKindReport,
} from "~/schemas/generated/graphql";

import { ISrrVariablesSpec } from "./reportsConfig";

interface ISelectOptionLike {
  value: string;
  label: string;
}

export interface ISrrVariablesFormData {
  groupReport?: ISelectOptionLike;
  numberTO?: ISelectOptionLike[];
  numberTOSingle?: ISelectOptionLike;
  numberGO?: ISelectOptionLike[];
  typeClient?: ISelectOptionLike[];
  salePeriod?: ISelectOptionLike;
  salePeriodStart?: Date;
  salePeriodEnd?: Date;
  monthControl?: Date;
  monthControlNs?: string | number;
  CarModel?: ISelectOptionLike[];
  kinds?: ISelectOptionLike[];
  kindReport?: ISelectOptionLike;
  dealerIds?: ISelectOptionLike[];
  lifetime?: string | number;
  method?: ISelectOptionLike;
  NOP?: string;
  RMP?: string;
  bonus?: string | number;
  loyaltyType?: ISelectOptionLike;
}

export const getSelectValuesEdition = (
  options: ISelectOptionLike[],
  enumObj: Record<string, string>,
) => options.map((item) => enumObj[item.value]);

export const buildSrrReportVariables = (
  spec: ISrrVariablesSpec,
  elem: ISrrVariablesFormData,
  baseFrom: Record<string, unknown>,
): Record<string, unknown> => {
  const variables: Record<string, unknown> = {};

  if (spec.baseFrom) {
    Object.assign(variables, baseFrom);
  }
  if (spec.groupKey) {
    variables[spec.groupKey] = TypeGroupReportSrr[elem.groupReport?.value];
  }
  if (spec.periodRange === "period") {
    variables.periodStart = elem.salePeriodStart;
    variables.periodEnd = elem.salePeriodEnd;
  }
  if (spec.periodRange === "periodOptional") {
    variables.periodStart = elem.salePeriodStart || undefined;
    variables.periodEnd = elem.salePeriodEnd || undefined;
  }
  if (spec.periodRange === "salePeriod") {
    variables.salePeriodStart = elem.salePeriodStart;
    variables.salePeriodEnd = elem.salePeriodEnd;
  }
  if (spec.monthControl) {
    variables.monthControl = elem.monthControl;
  }
  if (spec.salePeriod) {
    variables.salePeriod =
      elem.salePeriod?.value !== "Ничего не выбрано"
        ? elem.salePeriod?.value
        : undefined;
  }
  if (spec.car) {
    variables.CarModel = elem.CarModel
      ? elem.CarModel.length > 0
        ? getSelectValues(elem.CarModel)
        : []
      : [];
  }
  if (spec.familyCar) {
    variables.familyCar = elem.CarModel
      ? elem.CarModel.length > 0
        ? getSelectValues(elem.CarModel)
        : []
      : [];
  }
  if (spec.typeClient) {
    variables.typeClient = elem.typeClient
      ? elem.typeClient.length > 0
        ? getSelectValuesEdition(elem.typeClient, TypeClientReportSrr)
        : undefined
      : undefined;
  }
  if (spec.numberGO) {
    variables.numberGO =
      elem.numberGO && elem.numberGO.length > 0
        ? getSelectValuesEdition(elem.numberGO, TypeGoReportSrr)
        : Object.values(TypeGoReportSrr);
  }
  if (spec.lifetime) {
    variables.lifetime = Number(elem.lifetime);
  }
  if (spec.kindReport) {
    variables.kindReport = TypeKindReport[elem.kindReport?.value];
  }
  if (spec.kinds) {
    variables.kinds =
      elem.kinds && elem.kinds.length > 0
        ? getSelectValuesEdition(elem.kinds, KindRepair)
        : undefined;
  }
  if (spec.dealerIdsKey === "dealerIds") {
    variables.dealerIds = elem.dealerIds
      ? elem.dealerIds.length > 0
        ? getSelectValues(elem.dealerIds)
        : undefined
      : undefined;
  }
  if (spec.dealerIdsKey === "DealerIds") {
    variables.DealerIds = elem.dealerIds
      ? elem.dealerIds.length > 0
        ? getSelectValues(elem.dealerIds)
        : undefined
      : undefined;
  }
  if (spec.nsExtras || spec.nsDealerExtras) {
    variables.NOP = elem.NOP;
    variables.RMP = elem.RMP;
    variables.loyaltyType = LoyaltyType[elem.loyaltyType?.value];
  }
  if (spec.nsDealerExtras) {
    variables.bonus = elem.bonus ? Number(elem.bonus) : undefined;
    variables.monthControl = elem.monthControlNs
      ? Number(elem.monthControlNs)
      : undefined;
  }
  if (spec.invitation) {
    variables.dealerIds = elem.dealerIds
      ? elem.dealerIds.length > 0
        ? getSelectValues(elem.dealerIds)
        : []
      : [];
    variables.method = elem.method?.value;
    variables.numberTO = elem?.numberTOSingle?.value;
    variables.typeClient = elem.typeClient
      ? elem.typeClient.length > 0
        ? getSelectValuesEdition(elem.typeClient, TypeClientReportSrr)
        : []
      : [];
  }

  return variables;
};
